/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** Typed failure reasons returned by the claimLoyaltyPromotion mutation */
export type ClaimLoyaltyPromotionFailureReason =
  | 'CUSTOMER_INELIGIBLE_NEW_USER_GATE'
  | 'CUSTOMER_INELIGIBLE_SEGMENT_GATE'
  | 'EXPIRED_OFFER'
  | 'PREVIOUSLY_ISSUED'
  | 'UNABLE_TO_PROCESS';

/** Reward discount */
export type ClaimLoyaltyPromotionInput = {
  readonly offerId: string;
};

/** InStore = Reward can be redeemed in store, Delivery = Reward can be redeemed in delivery, Pickup = Reward can be redeemed in pickup, All = Reward can be redeemed in all channels */
export type RedemptionChannel = 'All' | 'Delivery' | 'InStore' | 'Kiosk' | 'Outpost' | 'Pickup';

/** PREMIUM = Reward is part of loyalty program, NON_PREMIUM = Reward is outcome of challenge/other outlet but not loyalty program */
export type RewardType = 'NON_PREMIUM' | 'PREMIUM';

export type ClaimLoyaltyPromotionMutationVariables = Exact<{
  input: Types.ClaimLoyaltyPromotionInput;
}>;

export type ClaimLoyaltyPromotionMutation = {
  readonly claimLoyaltyPromotion:
    | {
        readonly __typename: 'ClaimLoyaltyPromotionFailure';
        readonly reason: Types.ClaimLoyaltyPromotionFailureReason;
        readonly errorMessage: string;
      }
    | {
        readonly __typename: 'Reward';
        readonly id: string;
        readonly redeemable: boolean;
        readonly isFeatured: boolean;
        readonly redeemableAt: string | null;
        readonly rewardType: Types.RewardType;
        readonly expirationDate: string | null;
        readonly name: string;
        readonly redemptionChannel: Types.RedemptionChannel;
        readonly assetUrl: string | null;
        readonly terms: string;
      };
};

export const ClaimLoyaltyPromotionDocument = gql`
  mutation claimLoyaltyPromotion($input: ClaimLoyaltyPromotionInput!) {
    claimLoyaltyPromotion(input: $input) {
      ... on Reward {
        id
        __typename
        redeemable
        isFeatured
        redeemableAt
        rewardType
        expirationDate
        name
        redemptionChannel
        assetUrl
        terms
      }
      ... on ClaimLoyaltyPromotionFailure {
        __typename
        reason
        errorMessage
      }
    }
  }
`;

export function useClaimLoyaltyPromotionMutation() {
  return Urql.useMutation<ClaimLoyaltyPromotionMutation, ClaimLoyaltyPromotionMutationVariables>(
    ClaimLoyaltyPromotionDocument,
  );
}
